import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import male from "../../assets/images/male.png";
import leftArrow from "../../assets/images/leftArrow.png";
import { getUser, removeHost } from "../../store/user/action";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatCoin } from "../../util/formatCoin";

const T = {
  pageBg: "#33083e",
  text: "#EAF0FF",
  sub: "#9AA3B2",
  border: "rgba(255,255,255,0.08)",
  card: "#3c134e",
  radius: 16,
  shadow: "0 16px 36px rgba(0,0,0,0.35)",
  green: "#22C55E",
  rose: "#F43F5E",
  gradPink2: "#f2205f",
};

export const CreatorDetails = ({ skipFetch = false }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const agencyId = localStorage.getItem("agencyId");
  const [removingId, setRemovingId] = useState(null);
  const [pendingRemove, setPendingRemove] = useState(null);

  useEffect(() => {
    if (!skipFetch && agencyId) {
      dispatch(getUser(agencyId, { start: 1, limit: 200 }));
    }
  }, [dispatch, agencyId, skipFetch]);

  const handleOpenHostHistory = (id) => {
    navigate("/agencypanel/hosthistory", { state: id });
  };

  const handleRemoveHost = (host) => {
    if (!host?._id || !agencyId || removingId) return;
    // In-app confirm — Android WebView often blocks window.confirm
    setPendingRemove(host);
  };

  const confirmRemoveHost = async () => {
    if (!pendingRemove?._id || !agencyId || removingId) return;
    setRemovingId(pendingRemove._id);
    try {
      await dispatch(removeHost(pendingRemove._id, agencyId));
    } finally {
      setRemovingId(null);
      setPendingRemove(null);
    }
  };

  if (!user?.length) {
    return (
      <div
        style={{
          color: T.sub,
          textAlign: "center",
          padding: "40px 16px",
          fontWeight: 600,
        }}
      >
        {t("no_data_found")}
      </div>
    );
  }

  return (
    <>
    <div style={{ borderRadius: 12, paddingBottom: 28 }}>
      <div className="p-2 creatorDetails" style={{ background: T.pageBg }}>
        {user.map((data) => (
          <div
            key={data?._id}
            style={{
              borderRadius: 14,
              marginBottom: 12,
              background: T.card,
              border: `1px solid ${T.border}`,
              padding: 14,
              boxShadow: T.shadow,
            }}
          >
            <div className="d-flex align-items-start justify-content-between" style={{ gap: 10 }}>
              <div className="d-flex" style={{ gap: 12, minWidth: 0, flex: 1 }}>
                <img
                  src={data?.image ? data.image : male}
                  style={{
                    height: 44,
                    width: 44,
                    objectFit: "cover",
                    borderRadius: "50%",
                    border: `1px solid ${T.border}`,
                    flexShrink: 0,
                  }}
                  alt=""
                />
                <div style={{ minWidth: 0 }}>
                  <div className="d-flex align-items-center" style={{ gap: 8, flexWrap: "wrap" }}>
                    <p
                      className="mb-0 fw-bolder text-white"
                      style={{
                        fontSize: 15,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: 160,
                      }}
                    >
                      {data?.name ? data.name : "-"}
                    </p>
                    <span
                      style={{
                        border: "none",
                        padding: "2px 8px",
                        background: "#7B11E3",
                        borderRadius: 6,
                        color: "#fff",
                        fontSize: 11,
                        fontWeight: 600,
                      }}
                    >
                      {t("Host")}
                    </span>
                  </div>
                  <p className="mb-0 fw-bolder" style={{ fontSize: 13, color: "#EFCFE5", marginTop: 4 }}>
                    {t("ID")} : {data?.uniqueId ? data.uniqueId : "-"}
                  </p>
                </div>
              </div>

              <button
                type="button"
                disabled={removingId === data?._id}
                onClick={() => handleRemoveHost(data)}
                style={{
                  border: "none",
                  background: "rgba(244,63,94,0.16)",
                  color: T.rose,
                  borderRadius: 10,
                  padding: "8px 12px",
                  fontWeight: 700,
                  fontSize: 12,
                  cursor: removingId === data?._id ? "wait" : "pointer",
                  flexShrink: 0,
                }}
              >
                {removingId === data?._id ? "..." : t("remove_host")}
              </button>
            </div>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{ width: "100%", marginTop: 12, gap: 8, flexWrap: "wrap" }}
            >
              <div
                style={{
                  background: T.gradPink2,
                  color: "#fff",
                  padding: "4px 10px",
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: 13,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span style={{ fontWeight: 400 }}>{t("host_income")} :</span>
                {formatCoin(
                  data?.weekCoins != null ? data.weekCoins : data?.currentCoin || 0
                )}
                <span style={{ opacity: 0.85, fontWeight: 500, fontSize: 11 }}>
                  this week
                </span>
              </div>

              <button
                type="button"
                style={{ border: "none", background: "none", padding: 0 }}
                onClick={() => handleOpenHostHistory(data?._id)}
              >
                <p
                  className="mb-0 history"
                  style={{
                    color: "#E2CAD9",
                    fontWeight: 600,
                    fontSize: 14,
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                >
                  {t("history")}
                  <img src={leftArrow} alt="" height={20} width={20} />
                </p>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>

    {pendingRemove && (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.55)",
          zIndex: 10050,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
        }}
        onClick={() => !removingId && setPendingRemove(null)}
      >
        <div
          style={{
            background: T.card,
            border: `1px solid ${T.border}`,
            borderRadius: 16,
            padding: 20,
            width: "100%",
            maxWidth: 340,
            color: T.text,
            boxShadow: T.shadow,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 8 }}>
            {t("remove_host")}
          </div>
          <div style={{ color: T.sub, fontSize: 14, lineHeight: 1.45, marginBottom: 18 }}>
            {t("remove_host_confirm", {
              defaultValue: `Remove ${pendingRemove?.name || "this host"} from your agency?`,
              name: pendingRemove?.name || "this host",
            })}
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button
              type="button"
              disabled={!!removingId}
              onClick={() => setPendingRemove(null)}
              style={{
                border: `1px solid ${T.border}`,
                background: "transparent",
                color: T.text,
                borderRadius: 10,
                padding: "10px 14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              {t("cancel", { defaultValue: "Cancel" })}
            </button>
            <button
              type="button"
              disabled={!!removingId}
              onClick={confirmRemoveHost}
              style={{
                border: "none",
                background: T.rose,
                color: "#fff",
                borderRadius: 10,
                padding: "10px 14px",
                fontWeight: 700,
                cursor: removingId ? "wait" : "pointer",
                opacity: removingId ? 0.7 : 1,
              }}
            >
              {removingId ? "..." : t("remove_host")}
            </button>
          </div>
        </div>
      </div>
    )}
    </>
  );
};
